import axios from 'axios';

const ax = axios.create({
  baseURL: '/api/omalaakkonen/v2',
  headers: {
    'X-Requested-with': 'XHR'
  },
  validateStatus: function (status) {
    return status < 500; // Reject only if the status code is greater than or equal to 500
  }
});

class DataService {
  request(method, options) {
    return ax({
        method: method,
        url: options.url,
        data: options.data,
        params: options.params,
        withCredentials: true
      })
      .then(res => {
        const data = res.data;
        //console.log(res);
        if (res.status === 401) {
          this.vuexStore.commit('setLoggedIn', false);
          this.vuexStore.commit('setLogoutStatus', 'Istunto vanhentunut.');
          //console.log(res);
        }

        if (!this.vuexStore) {
          return data;
        }

        /*if(data.code === 200 && data.messages.length) {
        this.vuexStore.commit('addNotification', data.messages);
      }*/

        return data;
      })
      .catch(function (error) {
        if (error.response) {
          //const data = error.response.data;
          //console.error(`Server error status: ${data.code}\n${data.result.error.stack}`);
        }
      });
  }

  /**
   * If you're using dataService this with vuex, we can automatically logout user and do other stuff based on responses
   *
   * @param {Object} store - vuex store object
   */
  setVuexStore(store) {
    this.vuexStore = store;
  }

  get(path, params) {
    return this.request('get', {
      url: path,
      params: { ...params, cm_lang: 'fi_FI' },
    });
  }
  post(path, data, params) {
    return this.request('post', {
      url: path,
      data: data,
      params: { ...params, cm_lang: 'fi_FI' },
    });
  }
  patch(path, data, params) {
    return this.request('patch', {
      url: path,
      data: data,
      params: { ...params, cm_lang: 'fi_FI' },
    });
  }
  put(path, data, params) {
    return this.request('put', {
      url: path,
      data: data,
      params: { ...params, cm_lang: 'fi_FI' },
    });
  }
  delete(path, params) {
    return this.request('delete', {
      url: path,
      params: { ...params, cm_lang: 'fi_FI' },
    });
  }
}

export default new DataService();
